import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Tríceps Braquial
// 10 Básicas + 10 Generales + 10 Complejas

export const tricepsBraquialQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10031,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántas cabezas tiene el músculo tríceps braquial?",
    options: ["Dos", "Tres", "Cuatro", "Cinco"],
    correctAnswer: 1,
    explanation: "El tríceps braquial tiene tres cabezas: cabeza larga (se origina en el tubérculo infraglenoideo de la escápula), cabeza medial (superficie posterior del húmero) y cabeza lateral (superficie lateral del húmero). Todas convergen en un tendón común que se inserta en el olécranon del cúbito."
  },
  
  {
    id: 10032,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el tendón del tríceps braquial?",
    options: [
      "Tuberosidad del radio",
      "Olécranon del cúbito",
      "Epicóndilo medial del húmero",
      "Apófisis coronoidea del cúbito"
    ],
    correctAnswer: 1,
    explanation: "El tendón común del tríceps braquial se inserta en la superficie posterior del olécranon del cúbito. Esta inserción es crucial para su función como principal extensor del codo. El tendón es ancho y fuerte, resistiendo fuerzas significativas."
  },
  
  {
    id: 10033,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la acción principal del tríceps braquial?",
    options: [
      "Flexión del codo",
      "Supinación del antebrazo",
      "Extensión del codo",
      "Abducción del hombro"
    ],
    correctAnswer: 2,
    explanation: "La acción principal del tríceps braquial es la extensión del codo. Es el antagonista principal del bíceps braquial. La cabeza larga también contribuye a la aducción y extensión del hombro. Es el músculo más grande del brazo."
  },
  
  {
    id: 10034,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al tríceps braquial?",
    options: [
      "Nervio radial",
      "Nervio mediano",
      "Nervio musculocutáneo",
      "Nervio ulnar"
    ],
    correctAnswer: 0,
    explanation: "El nervio radial (C7-C8) inerva a todas las cabezas del tríceps braquial. Este nervio atraviesa el canal humeral (canal de torsión) entre las cabezas medial y lateral del tríceps, donde puede comprimirse causando parálisis radial."
  },
  
  {
    id: 10035,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria principal irriga al tríceps braquial?",
    options: [
      "Arteria braquial",
      "Arteria radial",
      "Arteria humeral profunda",
      "Arteria ulnar"
    ],
    correctAnswer: 2,
    explanation: "La arteria humeral profunda (braquial profunda) irriga principalmente al tríceps braquial. Esta arteria se origina de la arteria braquial y acompaña al nervio radial en el canal humeral, irrigando los músculos posteriores del brazo."
  },
  
  {
    id: 10036,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura anatómica pasa entre las cabezas del tríceps braquial?",
    options: [
      "Nervio mediano",
      "Nervio radial",
      "Arteria braquial",
      "Nervio musculocutáneo"
    ],
    correctAnswer: 1,
    explanation: "El nervio radial y la arteria humeral profunda pasan entre las cabezas medial y lateral del tríceps braquial en el canal humeral. Esta relación explica por qué el tríceps puede estar afectado en lesiones del nervio radial."
  },
  
  {
    id: 10037,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué cabeza del tríceps es biarticular?",
    options: [
      "Cabeza lateral",
      "Cabeza medial",
      "Cabeza larga",
      "Todas son monoarticulares"
    ],
    correctAnswer: 2,
    explanation: "La cabeza larga del tríceps es biarticular porque cruza tanto la articulación glenohumeral (hombro) como la articulación del codo. Las cabezas medial y lateral son monoarticulares, cruzando solo el codo."
  },
  
  {
    id: 10038,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la cabeza larga del tríceps braquial?",
    options: [
      "Tubérculo mayor del húmero",
      "Tubérculo infraglenoideo de la escápula",
      "Superficie posterior del húmero",
      "Surco intertubercular"
    ],
    correctAnswer: 1,
    explanation: "La cabeza larga del tríceps se origina en el tubérculo infraglenoideo de la escápula. Su tendón pasa a través de la articulación del hombro, explicando su vulnerabilidad a lesiones en subluxaciones o luxaciones glenohumerales."
  },
  
  {
    id: 10039,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué cabeza del tríceps es la más potente?",
    options: [
      "Cabeza larga",
      "Cabeza medial",
      "Cabeza lateral",
      "Todas tienen la misma potencia"
    ],
    correctAnswer: 1,
    explanation: "La cabeza medial es la más potente del tríceps braquial. Contiene más fibras tipo I (lentas) y es la que se activa más durante movimientos finos y sostenidos. Es especialmente importante en atletas de élite y en la rehabilitación."
  },
  
  {
    id: 10040,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuál es la característica principal del tendón distal del tríceps?",
    options: [
      "Es muy fino y delicado",
      "Es ancho y fuerte",
      "Se divide en dos inserciones",
      "Se inserta en el radio"
    ],
    correctAnswer: 1,
    explanation: "El tendón distal del tríceps es ancho y fuerte, siendo uno de los tendones más resistentes del cuerpo. Su amplia inserción en el olécranon le da una ventaja mecánica excelente para la extensión del codo."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10041,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye la cabeza larga del tríceps a la función del hombro?",
    options: [
      "Es el principal flexor del hombro",
      "Ayuda en la extensión y aducción",
      "Es el principal abductor",
      "No cruza la articulación del hombro"
    ],
    correctAnswer: 1,
    explanation: "La cabeza larga del tríceps contribuye a la extensión y aducción del hombro. Es especialmente activa durante movimientos como el press de pecho o al bajar objetos por encima de la cabeza. Su acción es más pronunciada con el brazo en abducción."
  },
  
  {
    id: 10042,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como sinergistas del tríceps en la extensión del codo?",
    options: [
      "Bíceps y braquial",
      "Braquiorradial y ancóneo",
      "Pronador cuadrado",
      "Flexores de la muñeca"
    ],
    correctAnswer: 1,
    explanation: "Los sinergistas del tríceps en la extensión del codo son el braquiorradial y el ancóneo. El ancóneo es especialmente importante para movimientos finos de extensión, mientras que el braquiorradial ayuda en posiciones neutras del antebrazo."
  },
  
  {
    id: 10043,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué ramas específicas irrigan las diferentes cabezas del tríceps?",
    options: [
      "Todas por arteria humeral profunda",
      "Cabeza larga por arteria circunfleja, otras por humeral profunda",
      "Cada cabeza por rama específica de la braquial",
      "Irrigación principalmente por arteria colateral radial"
    ],
    correctAnswer: 1,
    explanation: "La cabeza larga recibe irrigación de la arteria circunfleja (ramas de la axilar), mientras que las cabezas medial y lateral son irrigadas principalmente por la arteria humeral profunda. Esta doble irrigación explica por qué la cabeza larga puede lesionarse independientemente."
  },
  
  {
    id: 10044,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿De qué raíces nerviosas se origina la inervación del tríceps?",
    options: [
      "C5-C6",
      "C6-C7",
      "C7-C8",
      "C8-T1"
    ],
    correctAnswer: 2,
    explanation: "El nervio radial que inerva al tríceps se origina principalmente de C7-C8, con contribuciones menores de C6. La lesión del nervio radial en el canal humeral causa parálisis completa del tríceps (signo de caída) y pérdida de extensión del codo."
  },
  
  {
    id: 10045,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante más común del tríceps braquial?",
    options: [
      "Ausencia de la cabeza larga",
      "Cuarta cabeza accesoria",
      "Fusión con el ancóneo",
      "Inserción doble en el olécranon"
    ],
    correctAnswer: 1,
    explanation: "La presencia de una cuarta cabeza accesoria (cabeza accesoria) es la variante más común del tríceps, ocurriendo en 3-8% de la población. Generalmente se origina del húmero distal y se inserta con el tendón principal, aumentando la fuerza de extensión."
  },
  
  {
    id: 10046,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test clínico evalúa específicamente la integridad del tríceps?",
    options: [
      "Test de extensión resistida del codo",
      "Test de pinza",
      "Test de tracción",
      "Test de abducción"
    ],
    correctAnswer: 0,
    explanation: "El test de extensión resistida del codo evalúa la integridad del tríceps. El paciente extiende el codo contra resistencia. Debilidad indica lesión del músculo o nervio radial. Es positivo cuando el paciente no puede mantener la extensión contra gravedad."
  },
  
  {
    id: 10047,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué masa muscular embrionaria se desarrolla el tríceps braquial?",
    options: [
      "Masa flexora ventral",
      "Masa extensora dorsal",
      "Masa pronadora",
      "Masa supinadora"
    ],
    correctAnswer: 1,
    explanation: "El tríceps braquial se desarrolla de la masa muscular extensora dorsal del miembro superior, alrededor de la 5-6 semana de gestación. Las tres cabezas se diferencian progresivamente, con la cabeza larga apareciendo primero durante el desarrollo."
  },
  
  {
    id: 10048,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el tríceps?",
    options: [
      "100% fibras tipo I",
      "100% fibras tipo II",
      "60% tipo I, 40% tipo II",
      "40% tipo I, 60% tipo II"
    ],
    correctAnswer: 3,
    explanation: "El tríceps braquial tiene predominio de fibras tipo II (rápidas, 60%) sobre tipo I (lentas, 40%). La cabeza medial tiene mayor proporción de fibras tipo I, explicando su importancia en movimientos finos y sostenidos. Las cabezas lateral y larga son más glucolíticas."
  },
  
  {
    id: 10049,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura tendinosa separa las cabezas medial y lateral del tríceps?",
    options: [
      "Tabique intermuscular medial",
      "Tabique intermuscular lateral",
      "Septum humerotricipital",
      "Fascia braquial"
    ],
    correctAnswer: 2,
    explanation: "El septum humerotricipital (tabique humerotricipital) es una estructura fascial que separa las cabezas medial y lateral del tríceps. Se origina del húmero y contiene el paso del nervio radial y arteria humeral profunda hacia el compartimento posterior del brazo."
  },
  
  {
    id: 10050,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el tríceps es menos eficiente en extensión completa del codo?",
    options: [
      "Por la contracción del bíceps",
      "Por el ángulo de tracción del tendón",
      "Por la compresión del olecranon",
      "Por la posición del nervio radial"
    ],
    correctAnswer: 1,
    explanation: "En extensión completa del codo, el ángulo de tracción del tendón del tríceps sobre el olécranon es menos favorable, disminuyendo su eficiencia. La máxima eficiencia ocurre con el codo a 90 grados, cuando el tendón forma un ángulo óptimo con el antebrazo."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10051,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con debilidad para extender el codo y caída de la mano. ¿Qué nivel de lesión del nervio radial sugiere esto?",
    options: [
      "Lesión proximal al canal humeral",
      "Lesión en el canal humeral",
      "Lesión distal al epicóndilo lateral",
      "Lesión en el antebrazo"
    ],
    correctAnswer: 1,
    explanation: "La combinación de debilidad del tríceps (extensión del codo) y caída de la mano (extensores de muñeca) indica lesión del nervio radial en el canal humeral, donde inerva al tríceps y luego continúa hacia los extensores del antebrazo. Lesiones más proximales afectarían solo al tríceps."
  },
  
  {
    id: 10052,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Atleta presenta dolor posterolateral del codo al extender contra resistencia. ¿Cuál es el diagnóstico más probable?",
    options: [
      "Tendinitis del tríceps",
      "Síndrome de compresión del nervio radial",
      "Epicondilitis lateral",
      "Bursitis olecraniana"
    ],
    correctAnswer: 0,
    explanation: "La tendinitis del tríceps es común en atletas que realizan movimientos repetitivos de extensión (pesas, lanzamiento). El dolor se localiza en la inserción olecraniana. Se trata con reposo, hielo, AINEs y modificación de técnica. La cirugía es rara, consistente en desbridamiento tendinoso."
  },
  
  {
    id: 10053,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se prefiere para reparar una ruptura completa del tendón distal del tríceps?",
    options: [
      "Abordaje posterior longitudinal",
      "Abordaje posterolateral",
      "Abordaje medial",
      "Abordaje anterior con osteotomía"
    ],
    correctAnswer: 0,
    explanation: "El abordaje posterior longitudinal centrado en el olécranon es el estándar para reparación del tendón distal del tríceps. Permite exposición directa de la inserción ósea. Se usa técnica de anclas o sutura transósea. Las rupturas completas requieren reparación quirúrgica para restaurar extensión del codo."
  },
  
  {
    id: 10054,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM del brazo, ¿qué hallazgo confirma ruptura parcial de la cabeza larga del tríceps?",
    options: [
      "Engrosamiento difuso del tendón",
      "Señal hiperintensa en T2 en el origen",
      "Atrofia del músculo",
      "Calcificaciones intratendinosas"
    ],
    correctAnswer: 1,
    explanation: "La ruptura parcial de la cabeza larga del tríceps muestra señal hiperintensa en T2-STIR en el origen del tubérculo infraglenoideo, con disrupción parcial de las fibras tendinosas. Las rupturas completas muestran retracción del tendón y hematoma. La ecografía es útil para evaluación dinámica."
  },
  
  {
    id: 10055,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede surgir de una reparación quirúrgica agresiva del tendón del tríceps?",
    options: [
      "Rigidez del codo",
      "Lesión del nervio ulnar",
      "Compresión de la arteria braquial",
      "Lesión del nervio interóseo posterior"
    ],
    correctAnswer: 3,
    explanation: "La reparación quirúrgica agresiva del tendón del tríceps puede lesionar el nervio interóseo posterior (rama del radial) que pasa posterior al epicóndilo lateral. Esto causa debilidad selectiva de los extensores de dedos y muñeca, preservando extensión del codo (que depende del nervio radial directo)."
  },
  
  {
    id: 10056,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con antecedente de luxación glenohumeral presenta ruptura aguda de cabeza larga del tríceps. ¿Qué factor predisponente es más probable?",
    options: [
      "Uso crónico de esteroides",
      "Trauma directo",
      "Degeneración por inestabilidad glenohumeral",
      "Sobreentrenamiento"
    ],
    correctAnswer: 2,
    explanation: "La inestabilidad glenohumeral crónica predispone a ruptura de la cabeza larga del tríceps. El tendón intraarticular sufre microtraumatismos repetidos durante subluxaciones, causando degeneración. Las rupturas agudas sobre base degenerativa son más comunes que las traumáticas puras en atletas."
  },
  
  {
    id: 10057,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación isocinética muestra déficit selectivo de extensión rápida del codo. ¿Qué cabeza del tríceps está afectada?",
    options: [
      "Cabeza larga",
      "Cabeza medial",
      "Cabeza lateral",
      "Todas las cabezas"
    ],
    correctAnswer: 2,
    explanation: "La cabeza lateral del tríceps es la más activa en movimientos rápidos y explosivos. Contiene mayor proporción de fibras tipo IIb (rápidas glucolíticas). La cabeza medial es más importante en movimientos finos y sostenidos. La cabeza larga contribuye menos a la potencia pura de extensión."
  },
  
  {
    id: 10058,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica de reparación tendinosa se prefiere para rupturas crónicas del tríceps (>6 semanas)?",
    options: [
      "Reparación directa con anclas",
      "Reconstrucción con autoinjerto",
      "Transferencia del ancóneo",
      "Liberación y avance tendinoso"
    ],
    correctAnswer: 1,
    explanation: "Las rupturas crónicas del tríceps requieren reconstrucción con autoinjerto (grácil o semitendinoso) debido a la retracción tendinosa y formación de tejido cicatricial. La reparación directa falla por tensión excesiva. El procedimiento incluye desbridamiento del hueso olecraniano y tunelización para anclaje."
  },
  
  {
    id: 10059,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía dinámica del codo, ¿qué maniobra confirma tenosinovitis del tríceps?",
    options: [
      "Flexión-extensión pasiva",
      "Pronación-supinación",
      "Compresión directa del tendón",
      "Movimiento de pinza"
    ],
    correctAnswer: 0,
    explanation: "La ecografía dinámica durante flexión-extensión del codo evalúa el deslizamiento del tendón del tríceps. En la tenosinovitis, se observa líquido en la vaina tendinosa que aumenta con movimiento, dolor a la palpación ecográfica, y engrosamiento sinovial. Es más sensible que la RM para evaluación dinámica."
  },
  
  {
    id: 10060,
    muscle: 'triceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Atleta de lanzamiento presenta hipertrofia selectiva de la cabeza medial del tríceps. ¿Qué explica este hallazgo?",
    options: [
      "Compensación por lesión de cabeza lateral",
      "Entrenamiento específico de fuerza",
      "Variante anatómica",
      "Uso de esteroides anabólicos"
    ],
    correctAnswer: 1,
    explanation: "La hipertrofia selectiva de la cabeza medial del tríceps ocurre en atletas que entrenan fuerza y resistencia (ej. gimnastas, lanzadores). Esta cabeza contiene más fibras tipo I y se activa durante movimientos lentos y controlados. El entrenamiento específico puede causar hipertrofia desproporcionada de una cabeza sobre las otras."
  }
];
